import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createUseStyles } from 'react-jss';
import { Theme } from '@wds/styles';
import { Box } from '@wds/box';
import { generateMetricsAttribute } from '@sm/metrics';
import { SurveyButton } from '../SurveyButton';

const DEFAULT_COPY = defineMessages({
  DONE: {
    id: 'ActionGroup.Done',
    defaultMessage: 'Done',
    description: '[Type: Button][Vis.: low] - Done button',
  },
});

const useStyles = createUseStyles((theme: Theme) => ({
  actionGroupContainer: {
    margin: [theme?.spacing[4], 80],
    fontSize: theme?.type.fontSize.cardTitle,
    overflowWrap: 'break-word',
  },
  actionGroupCTA: {
    padding: [0, theme?.spacing[5], theme?.spacing[4]],
    textAlign: 'center',
  },
  actionGroupButton: {
    padding: [15, 25],
  },
}));

export type Props = { qrDoneUrl: string };

function ActionGroup({ qrDoneUrl = '/' }: Props): React.ReactElement {
  const { actionGroupContainer, actionGroupCTA, actionGroupButton } = useStyles();
  const smMetrics = generateMetricsAttribute({
    data: {
      actionFlow: 'smwebQuizResultsDoneBtn',
      actionType: 'quiz_results_done',
      button: 'quiz_results_done',
      uiTrigger: 'quiz_results_done_btn',
      log: {
        level: 'info',
        message: 'smweb quiz results done button clicked',
      },
    },
  });

  return (
    <div className={actionGroupContainer}>
      <div className={actionGroupCTA}>
        <Box display="flex" flexJustify="center">
          <SurveyButton
            data-testid="ActionGroup__QuizDone"
            className={actionGroupButton}
            size="lg"
            href={qrDoneUrl}
            data-sm-metrics={smMetrics}
          >
            {t(DEFAULT_COPY.DONE)}
          </SurveyButton>
        </Box>
      </div>
    </div>
  );
}

export default ActionGroup;
